import React from 'react'
import Container from '@material-ui/core/Container';

class Page extends React.Component{

    render(){
        return(
            <Container maxWidth="lg">
                <div className="min-view">
                    {this.props.children}
                </div>
            </Container>
            
        )
    }
}

export default Page;


